import slick from '../plugins/slick.js';
import Headroom from '../plugins/headroom.js';

(function($) {

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Base = {
  // All pages
  common: {
    init: function() {
      /////
      // JavaScript to be fired on all pages
      /////

      // HEADROOM
      var myElement = document.querySelector(".global-header");
      // construct an instance of Headroom, passing the element
      var headroom  = new Headroom(myElement, {
        "offset": 150,
      });
      // initialise
      headroom.init(); 

      // News Masonry
      function masonry() {
        $('.news-posts .grid-item').each(function(){
          var $this = $(this);
          if ($this.prev('.grid-item').prev('.grid-item').length > 0) {
            var $offset = $this.offset().top - $this.prev('.grid-item').prev('.grid-item').offset().top - $this.prev('.grid-item').prev('.grid-item').outerHeight();
            if ($offset > 10) {
              $offset = '-' + $offset;
              $this.css('margin-top', $offset + 'px');
            }
          }
        });
      }
      if ($(window).width() > 767) {
        masonry();
      }

      // Mobile Nav
      $('#mobile-nav-toggle').on('click', function(){
        var $navheight = $('#mobile-navigation').height() + 170;
        $('body, html').toggleClass('nav-locked');
        $('#mobile-navigation-wrapper').toggleClass('active');
        $(this).toggleClass('collapsed');
      });
      // Resize for Match-Height and Slick-Slider glitch fix
      $(window).bind('load', function(){
        $(window).trigger('resize');
        setTimeout(function(){ $(window).trigger('resize'); }, 500);
      });
      $(window).scroll(this.scroll_actions);
      this.scroll_actions();

      $('#pagination').on('click', 'a', function(e){
        e.preventDefault();
        $(this).remove();
        $('.news-loader').load($(this).attr('href') + ' .news-posts>*', function(){
          $('.news-posts').append($('.news-loader').html());
          masonry();
        });
        $('#pagination').load($(this).attr('href') + ' #pagination>*');
      });

      $('.faq').on('click', function(){
        var $this = $(this);
        $this.toggleClass('active');
        // $('.faq').removeClass('shown');
        // $('.faq').not(this).removeClass('active');
        if ($this.hasClass('active')) {
          setTimeout(function(){
            $this.addClass('shown');
          }, 100 );
        } else {
          $this.removeClass('shown');
        }
      });

      // Video popups
      $('a').on('click', function(e){
        var $target = $(this).attr('href');
        if ($target.toLowerCase().indexOf("vimeo") >= 0) {
          e.preventDefault();
          var $n = $target.lastIndexOf('/');
          var $vid = $target.substring($n + 1);
          $('.popup-content').html('<iframe src="https://player.vimeo.com/video/' + $vid + '/?autoplay=1&api=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
          $('.video-popup-wrapper').addClass('active');
          $('body, html').addClass('body-noscroll');
        }
        if ($target.toLowerCase().indexOf("youtu") >= 0) {
          e.preventDefault();
          var $y = $target.lastIndexOf('=');
          var $yid = $target.substring($y + 1);
          $('.popup-content').html('<iframe src="https://www.youtube.com/embed/' + $yid + '/?autoplay=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
          $('.video-popup-wrapper').addClass('active');
          $('body, html').addClass('body-noscroll');
        }
      });
      $('.close-popup').on('click', function(){
        $('.video-popup-wrapper').removeClass('active');
        $('.popup-content').html('');
        $('body, html').removeClass('body-noscroll');
      });
      setTimeout(function(){
        $('.interior-hero .row, .error404-hero .row, .news-hero .row, .single-hero .row').addClass('shown');
      }, 100 );
    },
    scroll_actions: function() {
    }
  },
  // Home page
  home: {
    init: function() {
      setTimeout(function(){
        $('.home-hero .grid_6').addClass('shown');
      }, 100 );
      setTimeout(function(){
        $('.home-hero .grid_4').addClass('shown');
      }, 400 );
    }
  }
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
  fire: function(func, funcname, args) {
    var namespace = Base;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
      namespace[func][funcname](args);
    }
  },
  loadEvents: function() {
    UTIL.fire('common');

    $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
      UTIL.fire(classnm);
    });
  }
};

$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.